import { PageContentBlock } from '@malesia/react-components/dist/src/components/Page/ContentBlock';
import { SFC } from '@malesia/react-components/dist/src/types/react';
import React from 'react';
import { useInjectReducer, useInjectSaga } from '../../../utils/redux-injectors';
import { FlightCompanyListFooterWithStore } from './components/FlightCompanyListFooterWithStore';
import { FlightCompanyListHeaderWithStore } from './components/FlightCompanyListHeaderWithStore';
import { FlightCompanyListWithStore } from './components/FlightCompanyListWithStore';
import { getFlightCompanyListSaga } from './saga';
import { actions, reducer, sliceKey } from './slice';

export const FlightCompanyListPage: SFC = () => {
    useInjectReducer({ actions, key: sliceKey, reducer });
    useInjectSaga({ key: sliceKey, saga: getFlightCompanyListSaga });

    return (
        <PageContentBlock>
            <FlightCompanyListHeaderWithStore />
            <FlightCompanyListWithStore />
            <FlightCompanyListFooterWithStore />
        </PageContentBlock>
    );
};
